module.exports = __webpack_public_path__ + "img/logo-pemilihan-langsung.5cdc4672.png";